<template>
  <div>
    <b-modal
      id="modal-select"
      ref="modalSelect"
      :title="title"
      :modal-class="[isIOS ? 'modal-select-ios': '' ]"
      header-class="justify-content-center"
      footer-class="justify-content-center"
      no-close-on-esc
      no-close-on-backdrop
      centered
      :hide-footer="isIOS"
    >
      <template v-slot:modal-header>
        <template v-if="isIOS">
          <div class="modal-header-ios">
            <b-button variant="select" class="col-6 confirm" @click="confirm()">
            <div class="text-primary-2">完成</div>
          </b-button>
          </div>
      </template>
        <template v-else>
          <div class="title">
          {{ title }}
        </div>
        </template>


      </template>
      <select-swiper
        :filterType="filterType"
        :selectList="selectList"
        :monthActiveIdx="monthActiveIdx"
        :statusActiveIdx="statusActiveIdx"
        :swiperContainerHeight="isIOS ? '35' : '40'"
        @activeIdxEmit="activeIdxEmit"
      ></select-swiper>
      <!-- <div class="swiperBox">
        <swiper ref="mySwiper" :options="swiperOption" style="height: 40px">
          <swiper-slide
            v-for="(itme, index) in selectList"
            :key="index"
            :class="{ selectFirst: isSelectFirst, selectLast: isSelectLast }"
            >{{ itme.text }}</swiper-slide
          >

          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div> -->
      <template v-if="!isIOS" v-slot:modal-footer="{ close }" :class="'selectBox'">
        <div class="text-center">
          <b-button variant="select" class="col-6" @click="close()">
            <div>取消</div>
          </b-button>
          <b-button variant="select" class="col-6 confirm" @click="confirm()">
            <div>確認</div>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import CommonApiMixin from '@/mixins/commonApi';

import 'swiper/swiper-bundle.css';
// import { swiper, swiperSlide } from 'vue-awesome-swiper';
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'SelectModal',

  mixins: [CommonApiMixin],

  // components: { Swiper, SwiperSlide },
  // directives: {
  //   swiper: directive,
  // },

  props: {
    filterType: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    selectList: {
      type: Array,
      default: () => [],
    },
    monthActiveIdx: {
      type: Number,
      default: 0,
    },
    statusActiveIdx: {
      type: Number,
      default: 0,
    },
    isIOS: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    // const vue = this;
    return {
      isSelectFirst: false,
      isSelectLast: false,
      activeIdx: 0,
      // settings: {
      //   centerMode: false,
      //   slidesToShow: 1,
      //   slidesToScroll: 1,
      //   swipeToSlide: true,
      //   arrows: true,
      //   vertical: true,
      //   verticalSwiping: true,
      // },
      // swiperOption: {
      //   direction: 'vertical',
      //   paginationClickable: true,
      //   mousewheelControl: true,
      //   on: {
      //     init(swiper) {
      //       if (vue.filterType === 'M') {
      //         console.log('vue.monthActiveIdx', vue.monthActiveIdx);
      //         swiper.slideTo(vue.monthActiveIdx, 1, false);
      //         this.activeIdx = vue.monthActiveIdx;
      //       } else if (vue.filterType === 'S') {
      //         console.log('vue.statusActiveIdx', vue.statusActiveIdx);
      //         swiper.slideTo(vue.statusActiveIdx, 1, false);
      //         this.activeIdx = vue.statusActiveIdx;
      //       }
      //     },
      //     slideChangeTransitionStart() {
      //       console.log('realIndex', this.realIndex);
      //       vue.activeIdx = this.realIndex;
      //       // console.log('vue.activeIdx', vue.activeIdx);
      //     },
      //   },
      // },
    };
  },

  computed: {
    // 是否是注意事項
    isNotice() {
      return this.title !== '注意事項';
    },
  },
  methods: {
    activeIdxEmit(index) {
      this.activeIdx = index;
    },
    confirm() {
      this.$emit(
        'changeSelectValue',
        this.selectList[this.activeIdx],
        this.filterType,
        this.activeIdx
      );
    },
  },
};
</script>
